let timer = null
let triggerActive = false
let menuActive = false

function setup(trigger) {

    const USING_ACTIVE_CLASS = 'mega-active-always'
    const ACTIVE_CLASS = 'mega-active'
    const header = document.querySelector('header')
    const menus = Array.from(header.querySelectorAll('.desktop-mega--content'))
    const menu = document.querySelector(`[data-mega-id="${trigger.dataset.megaTrigger}"]`)

    if (!menu) {
        console.warn('This mega menu has no items.')
        return
    }

    trigger.addEventListener('mouseover', () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            menus.forEach(menu => {
                menu.classList.remove(ACTIVE_CLASS)
            })
            header.classList.add(ACTIVE_CLASS)
            menu.classList.add(ACTIVE_CLASS)
            triggerActive = true
        }, 200)
    })

    trigger.addEventListener('mouseout', () => {
        clearTimeout(timer)

        timer = setTimeout(() => {
            header.classList.remove(ACTIVE_CLASS)
            triggerActive = false
        }, 200)
    })

    menu.addEventListener('mouseover', () => {
        clearTimeout(timer)
        menuActive = true
    })

    menu.addEventListener('mouseout', () => {
        clearTimeout(timer)
        menuActive = false

        timer = setTimeout(() => {
            header.classList.remove(ACTIVE_CLASS)
        }, 200)
    })

}

export default function init() {
    const triggers = document.querySelectorAll('[data-mega-trigger]')
    if (!triggers) return

    triggers.forEach(setup)
}
